import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/DataEntry.css'
import dataEntryHero from "../../../assets/images/Data Entry Management.png";
import dataEntryProcess from "../../../assets/images/Data Entry Management.png";

const DataEntryPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> MIS Data Entry – BuddyTech Solutions </title>
        <meta name="description" content="Efficient and accurate data capture for CRM, ERP, invoices and inventory." />
        <meta name="keywords" content="data entry services, CRM data" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="MIS Data Entry – BuddyTech Solutions" />
        <meta property="og:description" content="Efficient and accurate data capture for CRM, ERP, invoices and inventory." />
        <meta property="og:keywords" content="data entry services, CRM data" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/mis/dataentry" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MIS Data Entry – BuddyTech Solutions" />
        <meta name="twitter:description" content="Efficient and accurate data capture for CRM, ERP, invoices and inventory." />
        <meta name="twitter:keywords" content="data entry services, CRM data" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="dataentry-container">
        <header className="dataentry-hero">
          <div className="dataentry-hero-content">
            <h1>Accurate & Efficient Data Entry</h1>
            <p>
              We offer reliable data entry services to digitize and organize information with precision, speed, and data security.
            </p>
          </div>
          <img src={dataEntryHero} alt="Data Entry Hero" className="dataentry-hero-img" />
        </header>

        <section className="dataentry-section">
          <div className="dataentry-text">
            <h2>Our Data Entry Expertise</h2>
            <p>
              From spreadsheets to complex enterprise databases, our team handles manual and automated data entry with full quality control.
            </p>
            <ul>
              <li>Offline & Online Data Entry</li>
              <li>Form Filling & Document Processing</li>
              <li>Excel, CRM & ERP Inputs</li>
              <li>Invoice, Billing & Inventory Logs</li>
              <li>Data Validation & Deduplication</li>
            </ul>
          </div>
          <img src={dataEntryProcess} alt="Data Entry Process" className="dataentry-img" />
        </section>

        <section className="dataentry-tools">
          <h2>Tools & Platforms</h2>
          <div className="tools-grid">
            <span>Microsoft Excel</span>
            <span>Google Sheets</span>
            <span>Zoho Forms</span>
            <span>Airtable</span>
            <span>ERP & CRM Systems</span>
            <span>FormStack</span>
            <span>PDF to Excel/CSV Tools</span>
            <span>Custom Portals</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:Augustine.g.1992@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917418763500" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917418763500">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default DataEntryPage;